var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrashRed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8136:40603)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.9235 7.47998C21.9035 7.47998 21.8735 7.47998 21.8435 7.47998C16.5535 6.94998 11.2735 6.74998 6.0435 7.27998L4.0035 7.47998C3.5835 7.51998 3.2135 7.21998 3.1735 6.79998C3.1335 6.37998 3.4335 6.01998 3.8435 5.97998L5.8835 5.77998C11.2035 5.23998 16.5935 5.44998 21.9935 5.97998C22.4035 6.01998 22.7035 6.38998 22.6635 6.79998C22.6335 7.18998 22.3035 7.47998 21.9235 7.47998Z",
    fill: "#D83612"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.42359 6.47C9.38359 6.47 9.34359 6.47 9.29359 6.46C8.89359 6.39 8.61359 6 8.68359 5.6L8.90359 4.29C9.06359 3.33 9.28359 2 11.6136 2H14.2336C16.5736 2 16.7936 3.38 16.9436 4.3L17.1636 5.6C17.2336 6.01 16.9536 6.4 16.5536 6.46C16.1436 6.53 15.7536 6.25 15.6936 5.85L15.4736 4.55C15.3336 3.68 15.3036 3.51 14.2436 3.51H11.6236C10.5636 3.51 10.5436 3.65 10.3936 4.54L10.1636 5.84C10.1036 6.21 9.78359 6.47 9.42359 6.47Z",
    fill: "#D83612"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1342 23.5001H9.71421C6.22421 23.5001 6.08422 21.5701 5.97422 20.0101L5.32422 9.94007C5.29422 9.53007 5.61421 9.17008 6.02421 9.14008C6.44421 9.12008 6.79422 9.43008 6.82422 9.84008L7.47422 19.9101C7.58422 21.4301 7.62421 22.0001 9.71421 22.0001H16.1342C18.2342 22.0001 18.2742 21.4301 18.3742 19.9101L19.0242 9.84008C19.0542 9.43008 19.4142 9.12008 19.8242 9.14008C20.2342 9.17008 20.5542 9.52007 20.5242 9.94007L19.8742 20.0101C19.7642 21.5701 19.6242 23.5001 16.1342 23.5001Z",
    fill: "#D83612"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5839 18H11.2539C10.8439 18 10.5039 17.66 10.5039 17.25C10.5039 16.84 10.8439 16.5 11.2539 16.5H14.5839C14.9939 16.5 15.3339 16.84 15.3339 17.25C15.3339 17.66 14.9939 18 14.5839 18Z",
    fill: "#D83612"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4238 14H10.4238C10.0138 14 9.67383 13.66 9.67383 13.25C9.67383 12.84 10.0138 12.5 10.4238 12.5H15.4238C15.8338 12.5 16.1738 12.84 16.1738 13.25C16.1738 13.66 15.8338 14 15.4238 14Z",
    fill: "#D83612"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8136:40603"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.923828 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashRed);
export default __webpack_public_path__ + "static/media/trashRed.375d52e78b63c48b9031ad9dd543d1b1.svg";
export { ForwardRef as ReactComponent };